{
  "validation": {
    "required": "Tieto on pakollinen",
    "invalidDate": "Virheellinen päivämäärä, syötä muodossa pp.kk.vvvv",
    "tooSmallDate": "Päivämäärä on liian pieni",
    "moveDateAfterEndDate": "Poismuuttopäivä ei voi olla myöhemmin kuin sopimuksen päättymispäivä.",
    "tooBigDate": "Päivämäärä on liian suuri",
    "invalidPostalCode": "Virheellinen postinumero",
    "invalidNumber": "Virheellinen numero",
    "tooBig": "Liian suuri arvo",
    "tooSmall": "Liian pieni arvo",
    "invalidIban": "Virheellinen tilinumero",
    "invalidBic": "Virheellinen BIC-tunnus",
    "invalidType": "Virheellinen arvo",
    "invalidEmail": "Virheellinen sähköpostiosoite",
    "invalidPhoneNumber": "Virheellinen puhelinnumero",
    "invalidString": "Virheellinen arvo",
    "invalidSsn": "Virheellinen henkilötunnus",
    "invalidPin": "Virheellinen tunnusluku",
    "invalidReturnPercentageSum": "Palautusprosenttien summan tulee olla 100 %.",
    "invalidRooReturnPercentageSum": "Asumisoikeusmaksun palautusosuuksien summan tulee olla 100 % tai kaikkien osuuksien tulee olla tyhjiä.",
    "titleDescriptionOrFilesRequired": "Otsikko, kuvaus tai liitetiedosto on pakollinen tieto",
    "noResidentUser": "Asukkaalla ei ole asukassivutunnusta. Tunnus pitää ensin luoda rekisteröitymällä asukassivulle.",
    "terminatedAdultMissingResidentUser": "Irtisanottavalta aikuiselta puuttuvat asukassivutunnukset. Henkilön irtisanominen ei ole mahdollista asukassivujen kautta.",
    "noAdultLeft": "Asuntoon ei jää yhtään täysi-ikäistä henkilöä, jolle sopimus voitaisiin siirtää.",
    "otherContractPartyTermination": "Toisen sopimusosapuolen voi irtisanoa vain kun irtisanoo koko sopimuksen.",
    "too_small_date": "Päivämäärä on liian pieni",
    "invalid_date": "Virheellinen päivämäärä",
    "too_big_date": "Päivämäärä on liian suuri",
    "move_date_after_end_date": "Poismuuttopäivä ei voi olla myöhemmin kuin sopimuksen päättymispäivä.",
    "invalid_postal_code": "Virheellinen postinumero",
    "invalid_number": "Virheellinen numero",
    "invalid_iban": "Virheellinen tilinumero",
    "invalid_bic": "Virheellinen BIC-tunnus",
    "invalid_email": "Virheellinen sähköpostiosoite",
    "invalid_phone_number": "Virheellinen puhelinnumero",
    "invalid_string": "Virheellinen arvo",
    "invalid_ssn": "Virheellinen henkilötunnus",
    "invalid_pin": "Virheellinen tunnusluku",
    "invalid_return_percentage_sum": "Palautusprosenttien summan tulee olla 100 %.",
    "invalid_roo_return_percentage_sum": "Asumisoikeusmaksun palautusosuuksien summan tulee olla 100 % tai kaikkien osuuksien tulee olla tyhjiä.",
    "title_description_or_files_required": "Otsikko, kuvaus tai liitetiedosto on pakollinen tieto",
    "no_resident_user": "Asukkaalla ei ole asukassivutunnusta. Tunnus pitää ensin luoda rekisteröitymällä asukassivulle.",
    "terminated_adult_missing_resident_user": "Irtisanottavalta aikuiselta puuttuvat asukassivutunnukset. Henkilön irtisanominen ei ole mahdollista asukassivujen kautta.",
    "no_adult_left": "Asuntoon ei jää yhtään täysi-ikäistä henkilöä, jolle sopimus voitaisiin siirtää.",
    "other_contract_party_termination": "Toisen sopimusosapuolen voi irtisanoa vain kun irtisanoo koko sopimuksen."
  },
  "other": {
    "noActiveContracts": "Sinulla ei ole tällä hetkellä voimassaolevaa sopimusta.",
    "errorFecthingContracts": "Virhe sopimuksia haettaessa, kokeile kirjautua uudelleen.",
    "internalError": "Jokin meni vikaan.",
    "internalErrorLogin": "Kokeile kirjautua uudelleen palveluun.",
    "genericError": "Oho, jokin meni pieleen. Yritä myöhemmin uudestaan.",
    "pageLoadTimedOut": "Sivun latauksessa tapahtui virhe. Yritä hetken kuluttua uudestaan.",
    "pageOutOfOrder": "Asukassivut eivät ole juuri nyt käytössä. Ole hyvä ja yritä myöhemmin uudelleen.",
    "staleClientRefreshRequired": "Sivu on päivittynyt. Lataa sivu uudelleen ja yritä irtisanomista uudestaan.",
    "identificationRequired": "Toimenpiteen vahvistaminen edellyttää vahvaa tunnistautumista. Tunnistaudu Omat tiedot -sivulla ja yritä uudelleen.",
    "pageNotFound": "Hakemaasi sivua ei löytynyt",
    "defectNoticeSubmitError": "Virhe vikailmoituksen lähetyksessä. Jos ongelma jatkuu, tai jos vika on kiireellinen ota yhteyttä asiakaspalveluun.",
    "defectNoticeAPIError": "Vikailmoituksen luonti ei juuri nyt onnistu. Ole hyvä ja yritä myöhemmin uudelleen.",
    "additionalNotification": "Kiireellisissä asioissa ota yhteys asiakaspalveluun.",
    "backToLogin": "Kirjautumissivulle",
    "registrationIsOutOfOrder": "Rekisteröityminen ei ole juuri nyt mahdollista. Ole hyvä ja yritä myöhemmin uudelleen.",
    "noPhoneNumber": "Vikailmoitus ei ole toiminnassa",
    "noPhoneNumberText": "Jatkaaksesi vikailmoituksen tekemistä, lisää puhelinnumerosi profiiliisi.",
    "failedToOpenAttachment": "Liitteen avaaminen epäonnistui",
    "errorLoadingBuilding": "Virhe kiinteistön tietojen haussa. Yritä myöhemmin uudelleen.",
    "incorrectRegistrationProvider": "Rekisteröityminen ei onnistu, yritä uudelleen.",
    "unboundResidentUser": "Virhe sopimuksia haettaessa. Ole yhteydessä asiakaspalveluumme.",
    "eventId": "Virhetunnus: {{id}}"
  },
  "auth": {
    "errorUserNotVerified": "Käyttäjän sähköpostiosoitetta ei ole vahvistettu",
    "invalidCredentials": "Virheellinen käyttäjätunnus tai salasana"
  }
}
